import { useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { Progress } from "antd";

export function VideoWrapper({
  containerHeight,
  videoSrc,
  setIsReadyToPlay,
  timestamps,
  currentFrame,
  isLandscape,
  videoHeight,
  framesData,
  isLoading,
  activeExtraction,
  extractionProgress,
  ratio,
}: any) {
  const videoRef = useRef<HTMLVideoElement>(null);

  let VIDEO_HEIGHT = window.screen.availHeight;

  function getVideoRatio(height: any) {
    const finalWidth = (height * 9) / 16;
    return finalWidth + "px";
  }
  function getLandscapeVideoRatio(height: any) {
    if (ratio) {
      return height * ratio + "px";
    }
    const finalWidth = (height * 16) / 9;
    return finalWidth + "px";
  }

  function getWidthForVideo(isLandscape: any) {
    return isLandscape
      ? getLandscapeVideoRatio(containerHeight)
      : getVideoRatio(containerHeight);
  }

  function getHeightForVideo(isLandscape: any) {
    if (videoHeight) {
      return videoHeight;
    }
    return isLandscape ? "100%" : `${containerHeight}px`;
  }

  const stylesForVideo: any = {
    height: getHeightForVideo(isLandscape),
    objectFit: "contain",
  };

  useEffect(() => {
    const video: any = videoRef.current;

    if (timestamps) {
      const displayFrames = () => {
        const timestamp = timestamps[currentFrame];
        if (
          typeof timestamp === "number" &&
          isFinite(timestamp) &&
          videoRef.current
        ) {
          video.currentTime = timestamp;
        }
      };

      displayFrames();
    }
  }, [currentFrame, videoSrc]);

  return (
    <div
      className={styles.videoContainer}
      style={{
        display: "block",
        margin: "0 auto",
        width: getWidthForVideo(isLandscape),
      }}
    >
      {activeExtraction &&
      framesData?.length > 0 &&
      extractionProgress === 100 ? (
        <img
          src={framesData[currentFrame]}
          alt="frame"
          style={stylesForVideo}
          className={styles.video}
          ref={videoRef as any}
        />
      ) : (
        <>
          <video
            src={`${videoSrc}`}
            ref={videoRef as any}
            style={stylesForVideo}
            className={styles.video}
            onCanPlayThrough={() => {
              setIsReadyToPlay(true);
            }}
            preload={"auto"}
          ></video>
          <ConditionalRenderer
            condition={
              activeExtraction &&
              extractionProgress > 0 &&
              extractionProgress < 100
            }
          >
            <div
              style={{
                position: "absolute",
                color: "white",
                top: "50px",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Progress
                type="dashboard"
                percent={extractionProgress}
                size="small"
                format={(percent) => (
                  <h4 style={{ color: "#006ab3" }}>{extractionProgress}%</h4>
                )}
              />
              {/* {extractionProgress}% */}
            </div>
          </ConditionalRenderer>
        </>
      )}
    </div>
  );
}
